import _objectSpread from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { Actions } from './index.constants';

var changeYear = function changeYear(date, newYear) {
  var actualDate = new Date(date);
  return new Date(actualDate.setFullYear(newYear));
};

var changeMonth = function changeMonth(date, quantity) {
  var actualDate = new Date(date);
  return new Date(actualDate.setMonth(actualDate.getMonth() + quantity));
};

var decreaseMonth = function decreaseMonth(date) {
  return changeMonth(date, -1);
};

var increaseMonth = function increaseMonth(date) {
  return changeMonth(date, 1);
};

var areSameMonth = function areSameMonth(date1, date2) {
  var newDate1 = new Date(date1);
  var newDate2 = new Date(date2);
  return newDate1.getMonth() === newDate2.getMonth() && newDate1.getFullYear() === newDate2.getFullYear();
};

var alreadySelectedAsInitial = function alreadySelectedAsInitial(state, date) {
  return state.selectedInitialDate && state.selectedInitialDate.toLocaleDateString() === date.toLocaleDateString();
};

var alreadySelectedAsFinal = function alreadySelectedAsFinal(state, date) {
  return state.selectedFinalDate && state.selectedFinalDate.toLocaleDateString() === date.toLocaleDateString();
};

var isFirstSelection = function isFirstSelection(state) {
  return !state.selectedInitialDate;
};

var initialIsBiggerThanFinal = function initialIsBiggerThanFinal(state, date) {
  return state.selectedInitialDate > date;
};

var currentDate = new Date();
var actualMonthDate = new Date(currentDate.setDate(1));
var lastMonthDate = decreaseMonth(currentDate);
export var initialState = {
  initialDate: lastMonthDate,
  finalDate: actualMonthDate,
  uniqDate: actualMonthDate,
  selectedInitialDate: null,
  selectedFinalDate: null
};
export var reducer = function reducer(state, action) {
  switch (action.type) {
    case Actions.DECREASE_INITIAL_MONTH:
      {
        var initialDate = decreaseMonth(state.initialDate);
        if (areSameMonth(state.finalDate, initialDate)) return _objectSpread({}, state);
        return _objectSpread(_objectSpread({}, state), {}, {
          initialDate: initialDate
        });
      }

    case Actions.INCREASE_INITIAL_MONTH:
      {
        var _initialDate = increaseMonth(state.initialDate);

        if (areSameMonth(state.finalDate, _initialDate)) return _objectSpread({}, state);
        return _objectSpread(_objectSpread({}, state), {}, {
          initialDate: _initialDate
        });
      }

    case Actions.DECREASE_FINAL_MONTH:
      {
        var finalDate = decreaseMonth(state.finalDate);
        if (areSameMonth(state.initialDate, finalDate)) return _objectSpread({}, state);
        return _objectSpread(_objectSpread({}, state), {}, {
          finalDate: finalDate
        });
      }

    case Actions.INCREASE_FINAL_MONTH:
      {
        var _finalDate = increaseMonth(state.finalDate);

        if (areSameMonth(state.initialDate, _finalDate)) return _objectSpread({}, state);
        return _objectSpread(_objectSpread({}, state), {}, {
          finalDate: _finalDate
        });
      }

    case Actions.CHANGE_YEAR:
      {
        var uniqDate = changeYear(state.uniqDate, action.year);
        return _objectSpread(_objectSpread({}, state), {}, {
          uniqDate: uniqDate
        });
      }

    case Actions.CHANGE_MONTH:
      {
        var _uniqDate = changeMonth(state.uniqDate, action.quantity);

        return _objectSpread(_objectSpread({}, state), {}, {
          uniqDate: _uniqDate
        });
      }

    case Actions.SELECT_DAY:
      {
        var selectedDate = new Date(action.year, action.month, action.day);
        if (alreadySelectedAsInitial(state, selectedDate)) return _objectSpread(_objectSpread({}, state), {}, {
          selectedInitialDate: state.selectedFinalDate,
          selectedFinalDate: null
        });
        if (alreadySelectedAsFinal(state, selectedDate)) return _objectSpread(_objectSpread({}, state), {}, {
          selectedFinalDate: null
        });
        if (isFirstSelection(state)) return _objectSpread(_objectSpread({}, state), {}, {
          selectedInitialDate: selectedDate
        });
        if (initialIsBiggerThanFinal(state, selectedDate)) return _objectSpread(_objectSpread({}, state), {}, {
          selectedInitialDate: selectedDate,
          selectedFinalDate: state.selectedInitialDate
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedFinalDate: selectedDate
        });
      }

    case Actions.SELECT_MONTH:
      {
        var selectedInitialDate = new Date(action.year, action.month, 1);
        var selectedFinalDate = new Date(action.year, action.month + 1, 0);
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedInitialDate: selectedInitialDate,
          selectedFinalDate: selectedFinalDate
        });
      }

    case Actions.SELECT_YEAR:
      {
        var _selectedInitialDate = new Date(action.year, 0, 1);

        var _selectedFinalDate = new Date(action.year + 1, 0, 0);

        return _objectSpread(_objectSpread({}, state), {}, {
          selectedInitialDate: _selectedInitialDate,
          selectedFinalDate: _selectedFinalDate
        });
      }

    default:
      return state;
  }
};